<nav class="bg-base-100 border border-base-300 rounded-lg overflow-hidden h-full">
  <div class="px-4 py-3 border-b border-base-300 bg-base-200">
    <h3 class="text-sm font-bold text-primary uppercase tracking-wide">Source Types</h3>
  </div>
  <ul class="overflow-y-auto" style="max-height: calc(100vh - 220px);">
    <li>
      <button
        type="button"
        (click)="select(null)"
        [class.bg-info]="selectedSourceTypeId() === null"
        [class.text-white]="selectedSourceTypeId() === null"
        [class.font-semibold]="selectedSourceTypeId() === null"
        class="w-full text-left px-4 py-3 text-sm text-primary hover:bg-base-200 transition-colors flex items-center justify-between border-b border-base-300"
      >
        <span>Core</span>
        <span
          *ngIf="countByScope().get(null) as count"
          class="badge badge-sm"
          [class.bg-base-100]="selectedSourceTypeId() === null"
          [class.text-primary]="selectedSourceTypeId() === null"
        >
          {{ count }}
        </span>
      </button>
    </li>
    <li *ngFor="let st of sourceTypes(); trackBy: trackById">
      <button
        type="button"
        (click)="select(st.id)"
        [class.bg-info]="selectedSourceTypeId() === st.id"
        [class.text-white]="selectedSourceTypeId() === st.id"
        [class.font-semibold]="selectedSourceTypeId() === st.id"
        class="w-full text-left px-4 py-3 text-sm text-primary hover:bg-base-200 transition-colors flex items-center justify-between border-b border-base-300"
      >
        <span>{{ st.name }}</span>
        <span
          *ngIf="countByScope().get(st.id) as count"
          class="badge badge-sm"
          [class.bg-base-100]="selectedSourceTypeId() === st.id"
          [class.text-primary]="selectedSourceTypeId() === st.id"
        >
          {{ count }}
        </span>
      </button>
    </li>
  </ul>
</nav>
